'use strict';

import EventBus from '../utils/event-bus';

export default function () {
    const polite = document.createElement('div');
    polite.className = 'visually-hidden';
    polite.setAttribute('aria-live', 'polite');

    const assertive = document.createElement('div');
    assertive.className = 'visually-hidden';
    assertive.setAttribute('aria-live', 'assertive');

    document.body.appendChild(polite);
    document.body.appendChild(assertive);

    EventBus.on('announce', ({ message, priority = 'polite' }) => {
        const region = priority === 'assertive' ? assertive : polite;
        const existing = region.querySelector('span');
        if (existing) {
            region.removeChild(existing);
        }
        const span = document.createElement('span');
        span.textContent = message;
        region.appendChild(span);
    });
}
